module.exports = __webpack_public_path__ + "static/media/bg3.2f0a5287.png";